module.exports = {
	pt_BR_ssa: {


		label: {
			bem_vindo: 	'Bem Vindos, Soteropolitanos',
			dados_tipo_ocorrencia: 'Dados do tipo de Ocorrência SSA',			
			observacao: 'Ólhe',
			tipos_de_ocorrencias: 'Tipos de Ocorrências SSA',
		},

		MSG: {
			pesquise_nome_menu:	'Procure nome do menu em SSA',


		},

	  },
	  
  }